export default __webpack_public_path__ + "19e5f6c87257daac6eabf434b61bced3.png";